import { Bell, Calendar, CheckSquare, FileText, Filter, Info, LayoutGrid, MessageSquare,
  Search, Settings, Users } from '../../../icons';
import { tSettings } from '../../../lib/settings-i18n';

/**
 * 미리보기 (2026-08-20) — "실제 보기" 를 대신한다.
 *
 * 버튼·칩만 늘어놓던 옛 샘플로는 **레일·상태바 색을 확인할 수 없었다**. 그래서 6영역
 * (① 좌측 레일 · ② 메뉴 · ③ 본문 보드 · ④ 표·헤더 · ⑤ 우측 레일 · ⑥ 상태바)을 가진
 * 작은 화면을 그린다. 색은 전부 **인라인 CSS 변수**로 받는다 — 이 상자 안에서만 도는 값이라
 * 저장하지 않은 색을 보여줘도 화면 전체가 바뀌지 않는다.
 *
 * 아이콘 호버 색은 CSS `:hover` 로만 확인된다(마우스를 올려야 한다) — 그래서 레일 아이콘에
 * 호버 규칙을 걸어 두었다(ThemePanel.css).
 */

export interface PreviewColors {
  bg: string;
  rail: string;
  menu: string;
  rrail: string;
  status: string;
  table: string;
  thead: string;
  theadText: string;
  icon: string;
  iconHover: string;
  primary: string;
  primaryText: string;
  tint: string;
  line: string;
  text: string;
  muted: string;
}

export function ThemePreview({ c }: { c: PreviewColors }) {
  const style = {
    '--pv-bg': c.bg, '--pv-rail': c.rail, '--pv-menu': c.menu, '--pv-rrail': c.rrail,
    '--pv-status': c.status, '--pv-table': c.table, '--pv-thead': c.thead,
    '--pv-thead-text': c.theadText, '--pv-icon': c.icon, '--pv-icon-hover': c.iconHover,
    '--pv-primary': c.primary, '--pv-ptext': c.primaryText, '--pv-tint': c.tint,
    '--pv-line': c.line, '--pv-text': c.text, '--pv-muted': c.muted,
  } as React.CSSProperties;

  return (
    <div className="pv-scr" style={style} aria-hidden>
      <div className="pv-scr__body">
        <div className="pv-scr__rail">
          <span className="pv-scr__brand" />
          <span className="pv-ic is-on"><LayoutGrid size={12} /></span>
          <span className="pv-ic"><MessageSquare size={12} /></span>
          <span className="pv-ic"><Calendar size={12} /></span>
          <span className="pv-scr__sp" />
          <span className="pv-ic"><Settings size={12} /></span>
        </div>

        <div className="pv-scr__menu">
          <span className="pv-scr__mt">{tSettings('settings.theme.lg_menu')}</span>
          <span className="pv-mi is-on"><FileText size={11} />{tSettings('settings.theme.s_all')}</span>
          <span className="pv-mi"><CheckSquare size={11} />{tSettings('settings.theme.s_doing')}</span>
          <span className="pv-mi"><Users size={11} />{tSettings('settings.theme.s_shared')}</span>
        </div>

        <div className="pv-scr__main">
          <div className="pv-scr__head">
            <b>{tSettings('settings.theme.lg_board')}</b>
            <span className="pv-scr__sp" />
            <span className="pv-iconbtn"><Search size={11} /></span>
            <span className="pv-iconbtn"><Filter size={11} /></span>
            <span className="pv-scr__btn">{tSettings('settings.btn.save')}</span>
          </div>
          <div className="pv-scr__table">
            <div className="pv-tr pv-tr--head"><span>{tSettings('settings.theme.lg_table')}</span></div>
            <div className="pv-tr">
              <span>2026-08-20.xlsx</span>
              <span className="pv-pill">{tSettings('settings.theme.s_doing')}</span>
            </div>
          </div>
        </div>

        <div className="pv-scr__rrail">
          <span className="pv-ic"><Bell size={11} /></span>
          <span className="pv-ic"><FileText size={11} /></span>
          <span className="pv-ic"><Info size={11} /></span>
        </div>
      </div>

      <div className="pv-scr__status">
        <span className="pv-scr__dot" />
        <span>{tSettings('settings.theme.s_done')}</span>
        <span className="pv-scr__sp" />
        <span>09:41</span>
      </div>
    </div>
  );
}
